export enum SharedResourceTypes {
  Recording = "Recording",
  CallDetail = "CallDetail",
}
